import React from 'react';
import { useMessage } from '@tmapy/intl';

import { InfoBadge } from '@tmapy/style-guide';

import { PUBLISHSET_TYPES } from '../constants';
import { publishsetTypesMessages } from './publishsetMessages';

type FormatTypeBadgeProps = {
  type: PUBLISHSET_TYPES;
};

export const FormatTypeBadge: React.FC<FormatTypeBadgeProps> = ({ type }) => {
  const formatMessage = useMessage();
  const label = type ? formatMessage.lookup(publishsetTypesMessages, PUBLISHSET_TYPES[type]) : '';

  switch (type) {
    case PUBLISHSET_TYPES.VECTOR: {
      return <InfoBadge>{label}</InfoBadge>;
    }
    case PUBLISHSET_TYPES.RASTER: {
      return <InfoBadge isStrong>{label}</InfoBadge>;
    }
    default: {
      console.error('FormatTypeBadge: Unknown type', type);
      return type;
    }
  }
};
